import theme, { HEADER_HEIGHT, HEADER_POSITION, HEADER_WIDTH } from '@services/theme'

import Config from '@features/config.json'

export default {
    root: {
        position: HEADER_POSITION,
        height: HEADER_HEIGHT,
        width: HEADER_WIDTH,
        backgroundColor: `${theme.palette.toolbar.background} !important`,
        zIndex: `${theme.zIndex.drawer + 1} !important`,
        borderBottom: `1px solid ${theme.palette.border.subtle.main}`
    },
    mainMenu: {
        [`&:hover`]: {
            borderRadius: 'O !important'
        }
    },
    menu: {
        marginRight: '24px'
    },
    rightIcon: {
        fontSize: '24px'
    },
    rightIconFilled: {
        fontVariationSettings: "'FILL' 1",
        fontSize: '24px'
    },
    product: {
        [`& img`]: Config.interface?.logoLeft ?? { display: 'none' },
        [`& span`]: {
            fontSize: '16px',
            fontWeight: 600,
            color: `${theme.palette.toolbar.color} !important`
        },
        marginRight: '70px'
    },
    links: {
        flexGrow: '1 !important',
        [theme.breakpoints.down('sm')]: {
            display: 'none'
        }
    },
    right: {
        [`& img`]: {
            height: '64px'
        }
    }
}